export default __webpack_public_path__ + "static/media/sun.4ab5faed.png";